import { cn } from '@/lib/utils';

type BadgeVariant = 'default' | 'primary' | 'green' | 'blue' | 'amber' | 'red' | 'purple';

const variantClasses: Record<BadgeVariant, string> = {
  default: 'bg-muted text-muted-foreground',
  primary: 'bg-primary/15 text-primary-foreground dark:text-primary',
  green: 'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-300',
  blue: 'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-300',
  amber: 'bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-300',
  red: 'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-300',
  purple: 'bg-purple-100 text-purple-700 dark:bg-purple-900/30 dark:text-purple-300',
};

interface BadgeProps {
  children: React.ReactNode;
  variant?: BadgeVariant;
  className?: string;
}

export function Badge({ children, variant = 'default', className }: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium',
        variantClasses[variant],
        className
      )}
    >
      {children}
    </span>
  );
}

const levelVariants: Record<number, { label: string; variant: BadgeVariant }> = {
  1: { label: 'Member', variant: 'default' },
  3: { label: 'Team Lead', variant: 'blue' },
  5: { label: 'Manager', variant: 'amber' },
  7: { label: 'HR Admin', variant: 'purple' },
  9: { label: 'Org Admin', variant: 'red' },
};

export function LevelBadge({ level }: { level: number }) {
  const config = levelVariants[level] ?? { label: `Level ${level}`, variant: 'default' as const };
  return <Badge variant={config.variant}>{config.label}</Badge>;
}
